import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';

import { baseURL_Radio_Compaign, baseURL } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';

export class SetMiniJackPot extends React.Component {

    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            showError: false,
            email_address: '',
            userDetail: false,
            // current_mini_jackpot: '',
            isShowError: false,
        }

        localStorage.setItem("phone_2", null);
    }

    onSubmit(e) {
        e.preventDefault();

        let formData = {
            "jackpot_amount": this.state.jackpot_amount
        }
        this.setState({ isLoading: true });
        var sha512 = require('js-sha512');
        let signature = sha512(this.state.jackpot_amount + 'P@s5w0rd_5@lt')

        axios.post(baseURL_Radio_Compaign + 'set_mini_jackpot', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "signature": signature
            },
        }).then((response) => {
            if (response.data.code = "0000") {

                // alert("ggkk")

                console.log("response_get", response.data)
                this.setState({
                    statusMessage: response.data.status,
                    isShowError: true, isLoading: false, showError: false,

                });
                setTimeout(() => {
                    this.setState({
                        statusMessage: response.data.status,
                        phone_number: '',
                        email_address: '',
                        userDetail: true,
                        isShowError: false, isLoading: false, showError: false,
                    });
                }, 3000);
            } else {
                this.setState({
                    statusMessage: response.data.message, email_address: '',
                    phone_number: '', userDetail: false, showError: true, isShowError: false, isLoading: false
                });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({
                showError: true,
                isShowError: false,
                phone_number: '',
                email_address: '',
                userDetail: false,
                statusMessage: error.response.data.message,
                submitted: true,
                isLoading: false
            });
        });


    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }



    componentDidMount() {
        axios.get(baseURL_Radio_Compaign + 'validators').then((response) => {

            // alert(baseURL_Radio_Compaign + 'validators')

            console.log("response_get", response.data)

            // alert(JSON.stringify(response.data.validators.mini_jackpot_winning))

            this.setState({
                current_mini_jackpot: response.data.validators.mini_jackpot_winning,
                current_live_jackpot: response.data.validators.live_jackpot_winning
            });
        }).catch(error => {
        })
    }

    formatCurrency = amount => {
        return new Intl.NumberFormat(this.state.locale, {
            style: 'currency',
            currency: "ABS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount).replaceAll('ABS', '');
    };


    render() {
        const { showComponent } = this.state;
        const { hideComponent, userDetail } = this.state;

        return (
            <div className="pcoded-main-container">
                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>
                                    <div className="card__title">
                                        <h5 className="bold-text">Set Mini JackPot</h5>
                                    </div>

                                    <h4>Current Mini JackPot:
                                        <b>
                                            {this.state.current_mini_jackpot != null ?
                                                this.formatCurrency(this.state.current_mini_jackpot) :
                                                this.state.current_mini_jackpot}
                                        </b>
                                    </h4>
                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}
                                    </div> : null}<br></br>
                                    {this.state.isShowError ? (
                                        <div color="success" style={{ fontSize: "13px", color: "green" }}>

                                            {this.state.statusMessage}

                                        </div>
                                    ) : null}<br></br>
                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>

                                        <span className="form__form-group-label">Jackpot amount</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-icon">
                                                <Card />
                                            </div>

                                            <input id="input" type="number" className="form-control input-md"
                                                name="jackpot_amount" placeholder="Enter Jackpot Amount"
                                                value={this.state.jackpot_amount} onChange={this.handleChange} />

                                        </div>
                                        <br />
                                        <div className="col-12">
                                            <br /><br />
                                            <Button type="submit" outline color="primary" className="float-right" >
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                                            </Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
